export default __webpack_public_path__ + "static/media/npi_id.260b9367.csv";